import { GenerateCommentaryResult } from '@aloft/toolkit-shared';
import { Block, Flex, Typography } from '@aloft/toolkit-sui';

export const GenerateCommentaryResults = ({ data }: { data: GenerateCommentaryResult }) => (
  <Block padding="16px" borderRadius="8px" backgroundColor="surface2">
    <Flex flexDirection="column" gap="8px">
      <Typography variant="h3">Generated commentary</Typography>
      <Typography variant="body1" __dangerDoNotUseSx={{ whiteSpace: 'pre-wrap' }}>
        {data.commentary}
      </Typography>
    </Flex>
  </Block>
);
